function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M1 1h7v7H1V1zm0 11h7v7H1v-7zm11 0h7v7h-7v-7z",
  fill: "transparent"
}), React.createElement("path", {
  fill: "#919EAB",
  className: "outline",
  d: "M19 11h-7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1zM8 11H1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1zM8 0H1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM2 18h5v-5H2v5zM2 7h5V2H2v5zm11 11v-5h5v5h-5zM12 6a1 1 0 1 1 0-2h2V2a1 1 0 1 1 2 0v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0V6h-2z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    className: "p_v3ASA",
    viewBox: "0 0 20 20",
    focusable: "false",
    "aria-hidden": "true"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/transactions.f05b21bb.svg";
export { SvgComponent as ReactComponent };